const copyViaSelection = (text: string) => {
	const textArea = document.createElement('textarea')
	textArea.value = text
	textArea.readOnly = true
	textArea.setAttribute('aria-hidden', 'true')
	textArea.style.cssText =
		'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:none;opacity:0;font-size:16px'

	const previouslyFocused = document.activeElement as HTMLElement | null
	const selection = document.getSelection()
	const previousRange =
		selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null

	document.body.appendChild(textArea)

	try {
		textArea.focus({ preventScroll: true })
		textArea.setSelectionRange(0, text.length)

		return document.execCommand('copy')
	} catch {
		return false
	} finally {
		textArea.remove()
		selection?.removeAllRanges()
		if (previousRange) {
			selection?.addRange(previousRange)
		}
		previouslyFocused?.focus?.({ preventScroll: true })
	}
}

const writeViaClipboardApi = async (text: string) => {
	try {
		await navigator.clipboard.writeText(text)
		return true
	} catch {
		return false
	}
}

export const copyToClipboard = async (text: string) => {
	if (!text || typeof document === 'undefined') {
		return false
	}

	if (
		typeof navigator !== 'undefined' &&
		typeof navigator.clipboard?.writeText === 'function'
	) {
		if (await writeViaClipboardApi(text)) {
			return true
		}

		if (!document.hasFocus()) {
			window.focus()

			if (await writeViaClipboardApi(text)) {
				return true
			}
		}
	}

	return copyViaSelection(text)
}
